import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";
import { setAuthCookies, setUserInfo } from "../../../cookies";

export const signupApi = createAsyncThunk(
  "user/signup",
  async (userData, { rejectWithValue }) => {
    try {
      return axios
        .post("/users/signup", userData)
        .then((response) => {
          const { data } = response.data;
          // Set authentication cookies after successful signup
          const { accessToken, refreshToken } = data.tokens;
          setAuthCookies(accessToken, refreshToken);

          // Store user information in localStorage (namespaced by app, see cookies.js)
          const user = data.user;
          const userLocalStorage = {
            firstName: user.firstName || null,
            lastName: user.lastName || null,
            gender: user.gender || null,
            email: user.email || null,
            phone: user.phone || null,
          };

          setUserInfo(userLocalStorage);

          return response.data;
        })
        .catch((error) => {
          const errorObject = error.response.data;
          return rejectWithValue(errorObject);
          //   return error;
        });
    } catch (error) {
      // Extract error message from API response
      return rejectWithValue("Signup failed");
    }
  }
);
